import _ from "lodash";

export async function handleCopyNo(registrations) {
  await navigator.clipboard.writeText(_(registrations).orderBy("number", "asc").map("player").join("\n"));
}

export async function handleCopyAz(registrations) {
  await navigator.clipboard.writeText(_(registrations).orderBy("player", "asc").map("player").join("\n"));
}
